export default class PricePartsInfoModel {
  constructor() {
    this.vehicleMake = []
    this.suppliers = []
    this.states = []
    this.config = []
    this.insurers = []
  }
}
